<template>
  <section class="app-main">
    <transition name="fade-transform" mode="out-in">

      <router-view :key="key" />
    </transition>
  </section>
</template>
<!-- :include="['ReportCommandorderInfo']" -->
<script>
export default {
  name: 'AppMain',
  computed: {
    key() {
      return this.$route.path
    }
  }
}
</script>

<style scoped>
.app-main {
  /*85 = navbar + tagsview  */
  height: calc(100vh - 90px);
  width: 100%;
  /* overflow:auto; */
  position: relative;
  background: #fff;
}
.fixed-header+.app-main {
  padding-top: 50px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
    padding: 0!important;
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
